import { s3StaticPath } from '@/define/consts/assets';
export const LIST_ASSET_POPULAR_CONSULTANT_BLUR = {
    base: `${s3StaticPath}/list/professional-blur-dummy.png`,
};
